import axios from 'axios';
import axiosHelper from 'utils/axiosHelper';

import { addNotification, NotificationImportance, closeAddReclamationDialog, closeClotureDialog, closeAnnulerClotureDialog, updateDropZone } from '../common/commonActions';
import { invalidateReclamationHistorique, fetchReclamationObservateursSuccess } from './detailsActions';
import { invalidateReclamationIndicateurEmises } from './indicateursActions';
import { invalidateReclamationIndicateurAffectees } from './indicateursActions';
import { invalidateReclamationIndicateurObservateur} from './indicateursActions';
import { invalidateReclamationIndicateurCommentaires } from './indicateursActions';
import { invalidateReclamationIndicateurCreees } from './indicateursActions';
import { invalidateReclamationIndicateurCloturees } from './indicateursActions';
import { invalidateTypeIndicateurs } from '../type/indicateursActions';
import { invalidateUtilisateurIndicateurs } from '../utilisateur/indicateursActions';
import { ReclamationActionDetailType } from 'constants.js';
import { TypeActionCodes } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

/**
 * Actions
 */
export const Actions = {
    FETCH_RECLAMATIONS_REQUEST: 'FETCH_RECLAMATIONS_REQUEST',
    FETCH_RECLAMATIONS_SUCCESS: 'FETCH_RECLAMATIONS_SUCCESS',
    FETCH_RECLAMATIONS_FAILURE: 'FETCH_RECLAMATIONS_FAILURE',

    FETCH_RECLAMATIONS_MAGASIN_REQUEST: 'FETCH_RECLAMATIONS_MAGASIN_REQUEST',
    FETCH_RECLAMATIONS_MAGASIN_SUCCESS: 'FETCH_RECLAMATIONS_MAGASIN_SUCCESS',
    FETCH_RECLAMATIONS_MAGASIN_FAILURE: 'FETCH_RECLAMATIONS_MAGASIN_FAILURE',

    UPDATE_RECHERCHE_CRITERES: 'UPDATE_RECHERCHE_CRITERES',
    RESET_RECHERCHE_CRITERES: 'RESET_RECHERCHE_CRITERES',
    SET_RECHERCHE_CRITERE_FILTRE: 'SET_RECHERCHE_CRITERE_FILTRE',
    SET_RECHERCHE_CRITERE_CODE_DEPOT: 'SET_RECHERCHE_CRITERE_CODE_DEPOT',
    SET_RECHERCHE_CRITERE_CODE_AGENCE: 'SET_RECHERCHE_CRITERE_CODE_AGENCE',

    INIT_ADD_RECLAMATION: 'INIT_ADD_RECLAMATION',

    ADD_RECLAMATION_REQUEST: 'ADD_RECLAMATION_REQUEST',
    ADD_RECLAMATION_SUCCESS: 'ADD_RECLAMATION_SUCCESS',
    ADD_RECLAMATION_FAILURE: 'ADD_RECLAMATION_FAILURE',

    NEXT_RECLAMATION: 'NEXT_RECLAMATION',

    AFFECTATION_REQUEST: 'AFFECTATION_REQUEST',
    AFFECTATION_SUCCESS: 'AFFECTATION_SUCCESS',
    AFFECTATION_FAILURE: 'AFFECTATION_FAILURE',
    AFFECTATION_WARNING: 'AFFECTATION_WARNING',

    AFFECTATION_CHANGE_GROUPE: 'AFFECTATION_CHANGE_GROUPE',
    AFFECTATION_CHANGE_UTILISATEUR: 'AFFECTATION_CHANGE_UTILISATEUR',
    AFFECTATION_CHANGE_OBSERVER: 'AFFECTATION_CHANGE_OBSERVER',

    FETCH_AFFECTATION_REQUEST: 'FETCH_AFFECTATION_REQUEST',
    FETCH_AFFECTATION_SUCCESS: 'FETCH_AFFECTATION_SUCCESS',
    FETCH_AFFECTATION_FAILURE: 'FETCH_AFFECTATION_FAILURE',

    ADD_MEMO_REQUEST: 'ADD_MEMO_REQUEST',
    ADD_MEMO_SUCCESS: 'ADD_MEMO_SUCCESS',
    ADD_MEMO_FAILURE: 'ADD_MEMO_FAILURE',

    ADD_QUESTION_REQUEST: 'ADD_QUESTION_REQUEST',
    ADD_QUESTION_SUCCESS: 'ADD_QUESTION_SUCCESS',
    ADD_QUESTION_FAILURE: 'ADD_QUESTION_FAILURE',

    CLOTURER_REQUEST: 'CLOTURER_REQUEST',
    CLOTURER_SUCCESS: 'CLOTURER_SUCCESS',
    CLOTURER_FAILURE: 'CLOTURER_FAILURE',

    ANNULER_CLOTURE_REQUEST: 'ANNULER_CLOTURE_REQUEST',
    ANNULER_CLOTURE_SUCCESS: 'ANNULER_CLOTURE_SUCCESS',
    ANNULER_CLOTURE_FAILURE: 'ANNULER_CLOTURE_FAILURE',

    ADD_ACTION_REQUEST: 'ADD_ACTION_REQUEST',
    ADD_ACTION_SUCCESS: 'ADD_ACTION_SUCCESS',
    ADD_ACTION_FAILURE: 'ADD_ACTION_FAILURE',

    DELETE_ACTION_REQUEST: 'DELETE_ACTION_REQUEST',
    DELETE_ACTION_SUCCESS: 'DELETE_ACTION_SUCCESS',
    DELETE_ACTION_FAILURE: 'DELETE_ACTION_FAILURE',

    FETCH_RECLAMATION_TRANSPORTEUR_REQUEST: 'FETCH_RECLAMATION_TRANSPORTEUR_REQUEST',
    FETCH_RECLAMATION_TRANSPORTEUR_SUCCESS: 'FETCH_RECLAMATION_TRANSPORTEUR_SUCCESS',
    FETCH_RECLAMATION_TRANSPORTEUR_FAILURE: 'FETCH_RECLAMATION_TRANSPORTEUR_FAILURE',

    SET_DATE_VERIFICATION_REQUEST: 'SET_DATE_VERIFICATION_REQUEST',
    SET_DATE_VERIFICATION_SUCCESS: 'SET_DATE_VERIFICATION_SUCCESS',
    SET_DATE_VERIFICATION_FAILURE: 'SET_DATE_VERIFICATION_FAILURE',

    INVALIDATE_RECHERCHE: 'INVALIDATE_RECHERCHE',

    GENERATE_PACKING_LIST_REQUEST: 'GENERATE_PACKING_LIST_REQUEST',
    GENERATE_PACKING_LIST_SUCCESS: 'GENERATE_PACKING_LIST_SUCCESS',
    GENERATE_PACKING_LIST_FAILURE: 'GENERATE_PACKING_LIST_FAILURE',



    TOGGLE_SUR_RETOUR_PALETTE_REQUEST: 'TOGGLE_SUR_RETOUR_PALETTE_REQUEST',
    TOGGLE_SUR_RETOUR_PALETTE_SUCCESS: 'TOGGLE_SUR_RETOUR_PALETTE_SUCCESS',
    TOGGLE_SUR_RETOUR_PALETTE_FAILURE: 'TOGGLE_SUR_RETOUR_PALETTE_FAILURE',
};

//
// FETCH_RECLAMATIONS
// ActionCreator pour la récuperation des données (réclamations)
//
const fetchReclamationsRequest = () => ({ type: Actions.FETCH_RECLAMATIONS_REQUEST });
const fetchReclamationsSuccess = reclamations => ({ type: Actions.FETCH_RECLAMATIONS_SUCCESS, reclamations });
const fetchReclamationsFailure = error => ({ type: Actions.FETCH_RECLAMATIONS_FAILURE, error });

export const invalidateRecherche = () => ({ type: Actions.INVALIDATE_RECHERCHE });

export const fetchReclamations = () => async (dispatch, getState) => {

    if (!getState().reclamation.reclamations.isLoading) {
        dispatch(fetchReclamationsRequest());

        let criteres = getState().reclamation.reclamations.recherche.criteres;

        try {
            let response = await axios.get('api/reclamations', { params: criteres, paramsSerializer: axiosHelper.transformRequestOptions });
            dispatch(fetchReclamationsSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamations : ', error);
            dispatch(fetchReclamationsFailure(error));
        }
    }
};

const shouldFetchReclamations = state => {
    if (state.reclamation.reclamations.isLoading) return false;
    else return state.reclamation.reclamations.recherche.didInvalidate;
};

export const fetchReclamationsIfNeeded = () => (dispatch, getState) => {
    if (shouldFetchReclamations(getState())) {
        return dispatch(fetchReclamations());
    }
};

//
// FETCH_RECLAMATIONS_MAGASIN
// ActionCreator pour la récuperation des données (réclamations magasin)
//
const fetchReclamationsMagasinRequest = () => ({ type: Actions.FETCH_RECLAMATIONS_MAGASIN_REQUEST });
const fetchReclamationsMagasinSuccess = reclamations => ({ type: Actions.FETCH_RECLAMATIONS_MAGASIN_SUCCESS, reclamations });
const fetchReclamationsMagasinFailure = error => ({ type: Actions.FETCH_RECLAMATIONS_MAGASIN_FAILURE, error });

export const fetchReclamationsMagasin = () => async (dispatch, getState) => {

    if (!getState().reclamation.reclamations.isLoading) {
        dispatch(fetchReclamationsMagasinRequest());

        let criteres = getState().reclamation.reclamations.recherche.criteres;

        try {
            let response = await axios.get('api/reclamations', { params: criteres, paramsSerializer: axiosHelper.transformRequestOptions });
            dispatch(fetchReclamationsMagasinSuccess(response.data));
        } catch (error) {
            console.error('fetchReclamationsMagasin : ', error);
            dispatch(fetchReclamationsMagasinFailure(error));
        }
    }
};

//
// ..._RECHERCHE
// ActionCreator pour la récupération des critères de recherche
//
export const updateRechercheCriteres = (criteres) => ({ type: Actions.UPDATE_RECHERCHE_CRITERES, criteres });
export const resetRechercheCriteres = () => ({ type: Actions.RESET_RECHERCHE_CRITERES });
export const setRechercheCritereFiltre = filtre => ({ type: Actions.SET_RECHERCHE_CRITERE_FILTRE, filtre });
export const setRechercheCritereCodeDepot = codeDepot => ({ type: Actions.SET_RECHERCHE_CRITERE_CODE_DEPOT, codeDepot });
export const setRechercheCritereCodeAgence = codeAgence => ({ type: Actions.SET_RECHERCHE_CRITERE_CODE_AGENCE, codeAgence });

//
// INIT_ADD_RECLAMATION
// ActionCreator pour l'initialisation de la création d'une réclamation.
//
export const initAddReclamation = () => ({ type: Actions.INIT_ADD_RECLAMATION });

//
// ADD_RECLAMATION...
// ActionCreator pour la création d'une réclamation.
//
const addReclamationRequest = () => ({ type: Actions.ADD_RECLAMATION_REQUEST });
const addReclamationSuccess = (reclamationId) => ({ type: Actions.ADD_RECLAMATION_SUCCESS, reclamationId });
const addReclamationFailure = () => ({ type: Actions.ADD_RECLAMATION_FAILURE });

const nextReclamation = (reclamation) => ({ type: Actions.NEXT_RECLAMATION, reclamation });

export const addReclamation = (reclamation) => async (dispatch) => {


        console.log('addReclamation', reclamation);

    try {
        dispatch(addReclamationRequest());

        let response = await axios.post('api/reclamations', reclamation);

        if (response.data.id > 0) {
            dispatch(addReclamationSuccess(response.data.id));

            if (response.data.message) {
                dispatch(addNotification(`Le dossier après-vente ${response.data.id} a été créé.\n${response.data.message}.`, response.data.importance, true));
            }
            else {
                dispatch(addNotification(`Le dossier après-vente ${response.data.id} a été créé.`, NotificationImportance.success));
            }

            if (response.data.prochaineReclamation) {

                console.log('addReclamation prochaineReclamation', response.data.prochaineReclamation);

                dispatch(nextReclamation(response.data.prochaineReclamation));
            }
            else {
                dispatch(closeAddReclamationDialog());
            }

            dispatch(invalidateReclamationIndicateurEmises());
            dispatch(invalidateReclamationIndicateurAffectees());
            dispatch(invalidateReclamationIndicateurObservateur());
            dispatch(invalidateReclamationIndicateurCommentaires());
            dispatch(invalidateReclamationIndicateurCreees());
            dispatch(invalidateReclamationIndicateurCloturees());

            dispatch(invalidateTypeIndicateurs());

            dispatch(invalidateUtilisateurIndicateurs());

            dispatch(invalidateRecherche());


            if (response.data.prochaineReclamation) {
                return 0;
            }
            else {
                // Redirection.
                return response.data.id;
            }
        }
        else {
            dispatch(addReclamationFailure());

            dispatch(addNotification(`Impossible de créer le dossier après-vente: ${response.data.message}.`, response.data.importance, true));
        }

        return -1;
    } catch (error) {
        console.error('addReclamation error=', error);
        console.error('addReclamation error=', JSON.stringify(error, null, 2));
        dispatch(addReclamationFailure());
        dispatch(addNotification(`Impossible de créer le dossier après-vente: ${error}.`, NotificationImportance.error));

        return -1;
    }
};

//
// ActionCreator pour l'affectation
//
export const openAffectationDialog = (reclamationId) => ({ type: Actions.OPEN_AFFECTATION_DIALOG, reclamationId });
export const closeAffectationDialog = () => ({ type: Actions.CLOSE_AFFECTATION_DIALOG });

const affectationRequest = () => ({ type: Actions.AFFECTATION_REQUEST });
const affectationSuccess = data => ({ type: Actions.AFFECTATION_SUCCESS, data });
const affectationFailure = error => ({ type: Actions.AFFECTATION_FAILURE, error });
const affectationWarning = affectation => ({ type: Actions.AFFECTATION_WARNING, affectation });

export const affecter = (details = [], forcer = false, declenchee = false) => async (dispatch, getState) => {

    if (!getState().reclamation.reclamations.isPatching) {
        dispatch(affectationRequest());

        let reclamation = getState().reclamation.reclamations.affectation.reclamation;

        let utilisateur = getState().reclamation.reclamations.affectation.utilisateur;

        let params = {
            groupeId: getState().reclamation.reclamations.affectation.groupe.id,
            utilisateurId: utilisateur ? utilisateur.id : 0,
            observer: getState().reclamation.reclamations.affectation.observateur,

            ancienGroupeId: reclamation.groupe.id,
            ancienUtilisateurId: reclamation.utilisateur ? reclamation.utilisateur.id : 0,
            forcer: forcer,
            details: details,
            declenchee: declenchee
        };

        try {

            let response = await axios.post(`api/reclamations/${reclamation.id}/affecter`, params);

            if (response.data.affecter) {

                dispatch(affectationSuccess(response.data.informations));
                dispatch(addNotification(`${response.data.message}`, NotificationImportance.success));
            }
            else {
                dispatch(addNotification(`Le dossier après-vente ${reclamation.id} n'a pas été affecté.\n${response.data.message}`, NotificationImportance.warning));
                dispatch(affectationWarning(response.data.informations));
            }

            dispatch(invalidateReclamationHistorique());
            dispatch(invalidateRecherche());

            dispatch(invalidateReclamationIndicateurEmises());
            dispatch(invalidateReclamationIndicateurAffectees());
            dispatch(invalidateReclamationIndicateurObservateur());
            dispatch(invalidateReclamationIndicateurCommentaires());
            dispatch(invalidateReclamationIndicateurCreees());
            dispatch(invalidateReclamationIndicateurCloturees());

            dispatch(invalidateTypeIndicateurs());

            dispatch(invalidateUtilisateurIndicateurs());

        } catch (error) {
            console.error('affectation : ', error);
            dispatch(affectationFailure(error));
            dispatch(addNotification(`Impossible d'affecter le dossier après-vente ${reclamation.id}.`, NotificationImportance.error));
        }
    }
};

export const modifierGroupeAffectation = (groupe) => ({ type: Actions.AFFECTATION_CHANGE_GROUPE, groupe });
export const modifierUtilisateurAffectation = (utilisateur) => ({ type: Actions.AFFECTATION_CHANGE_UTILISATEUR, utilisateur });
export const modifierObserverAffectation = (observateur) => ({ type: Actions.AFFECTATION_CHANGE_OBSERVER, observateur });

/**
 * ActionCreator pour récupérer les informations pour l'affectation
 */
const fetchAffectationRequest = () => ({ type: Actions.FETCH_AFFECTATION_REQUEST });
const fetchAffectationSuccess = affectation => ({ type: Actions.FETCH_AFFECTATION_SUCCESS, affectation });
const fetchAffectationFailure = error => ({ type: Actions.FETCH_AFFECTATION_FAILURE, error });

export const fetchAffectation = (id) => async (dispatch, getState) => {
    if (!getState().reclamation.details.isLoading) {
        dispatch(fetchAffectationRequest());

        try {
            let response = await axios.get(`api/reclamations/${id}/affecter`);
            dispatch(fetchAffectationSuccess(response.data));

            return response.data.reclamation.groupe.id;
        } catch (error) {
            console.error('fetchReclamation : ', error);
            dispatch(fetchAffectationFailure(error));
        }
    }
    return null;
};

//
// ActionCreator pour l'ajout d'un mémo
//
const addMemoRequest = () => ({ type: Actions.ADD_MEMO_REQUEST });
const addMemoSuccess = reclamationId => ({ type: Actions.ADD_MEMO_SUCCESS, reclamationId });
const addMemoFailure = error => ({ type: Actions.ADD_MEMO_FAILURE, error });

export const addMemo = (reclamationId, text, fichiersIds) => async (dispatch) => {

    dispatch(addMemoRequest());

    let params = {
        code: TypeActionCodes.Memo,
        details: [{
            code: ReclamationActionDetailCodes.Memo,
            type: ReclamationActionDetailType.Texte,
            libelle: "Texte du  mémo : ",
            position: 0,
            valeurString: text
        }]
    };

    if (fichiersIds.length > 0) {
        params = { ...params, fichiersIds: fichiersIds };
    }

    var dropZone = {
        fichiers: []
    };
    dispatch(updateDropZone(dropZone));

    try {
        let response = await axios.post(`api/reclamations/${reclamationId}/action`, params);
        dispatch(addMemoSuccess(response.data));

        if (response.data.message) {
            dispatch(addNotification(`Un mémo a bien été ajouté au dossier après-vente ${reclamationId}.\n${response.data.message}`, NotificationImportance.warning, true));
        }
        else {
            dispatch(addNotification(`Un mémo a bien été ajouté au dossier après-vente ${reclamationId}.`, NotificationImportance.success));
        }

        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());


        dispatch(invalidateReclamationIndicateurCommentaires());

    } catch (error) {
        dispatch(addMemoFailure(error));
        dispatch(addNotification(`Impossible d'ajouter un mémo au dossier après-vente ${reclamationId}.`, NotificationImportance.error));
    }
};

//
// ActionCreator pour l'ajout d'une question
//
const addQuestionRequest = () => ({ type: Actions.ADD_QUESTION_REQUEST });
const addQuestionSuccess = data => ({ type: Actions.ADD_QUESTION_SUCCESS, data });
const addQuestionFailure = error => ({ type: Actions.ADD_QUESTION_FAILURE, error });

export const addQuestion = (reclamationId, text, fichiersIds) => async (dispatch) => {

    dispatch(addQuestionRequest());

    let params = {
        code: TypeActionCodes.Question,
        details: [{
            code: ReclamationActionDetailCodes.Question,
            type: ReclamationActionDetailType.Texte,
            libelle: "Question :",
            position: 0,
            valeurString: text
        }],
        reponseAttendue: true
    };

    if (fichiersIds.length > 0) {
        params = { ...params, fichiersIds: fichiersIds };
    }

    var dropZone = {
        fichiers: []
    };
    dispatch(updateDropZone(dropZone));

    try {
        let response = await axios.post(`api/reclamations/${reclamationId}/action`, params);
        dispatch(addQuestionSuccess(response.data));


        if (response.data.message) {
            dispatch(addNotification(`Une question a bien été ajouté au dossier après-vente ${reclamationId}.\n${response.data.message}`, NotificationImportance.warning, true));
        }
        else {
            dispatch(addNotification(`Une question a bien été ajouté au dossier après-vente ${reclamationId}.`, NotificationImportance.success));
        }



        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurCommentaires());

    } catch (error) {
        dispatch(addQuestionFailure(error));
        dispatch(addNotification(`Impossible d'ajouter une question au dossier après-vente ${reclamationId}.`, NotificationImportance.error));
    }
};

//
// ActionCreator pour la cloture d'une réclamation.
//
const cloturerRequest = () => ({ type: Actions.CLOTURER_REQUEST });
const cloturerSuccess = data => ({ type: Actions.CLOTURER_SUCCESS, data });
const cloturerFailure = error => ({ type: Actions.CLOTURER_FAILURE, error });

export const cloturer = (reclamationId, cloture) => async (dispatch) => {
    try {
        dispatch(cloturerRequest());

        let response = await axios.post(`api/reclamations/${reclamationId}/cloturer`, cloture);

        dispatch(cloturerSuccess(response.data));
        dispatch(closeClotureDialog());

        if (!response.data.message) {
            dispatch(addNotification(`Le dossier après-vente ${reclamationId} a bien été clôturé.`, NotificationImportance.success));
        } else {
            dispatch(addNotification(`Le dossier après-vente ${reclamationId} a bien été clôturé.\n${response.data.message}`, response.data.importance, true, null));
        }

        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurEmises());
        dispatch(invalidateReclamationIndicateurAffectees());
            dispatch(invalidateReclamationIndicateurObservateur());
        dispatch(invalidateReclamationIndicateurCommentaires());
        dispatch(invalidateReclamationIndicateurCreees());
        dispatch(invalidateReclamationIndicateurCloturees());

        dispatch(invalidateTypeIndicateurs());

        dispatch(invalidateUtilisateurIndicateurs());

    } catch (error) {
        dispatch(cloturerFailure(error));
        dispatch(addNotification(`Impossible de clôturer le dossier après-vente ${reclamationId}: ${error}`, NotificationImportance.error));
    }
};

//
// ActionCreator pour l'annulation de la cloture d'une réclamation.
//
const annulerClotureRequest = () => ({ type: Actions.ANNULER_CLOTURE_REQUEST });
const annulerClotureSuccess = data => ({ type: Actions.ANNULER_CLOTURE_SUCCESS, data });
const annulerClotureFailure = error => ({ type: Actions.ANNULER_CLOTURE_FAILURE, error });

export const annulerCloture = (reclamationId) => async (dispatch) => {
    try {
        dispatch(annulerClotureRequest());

        let response = await axios.post(`api/reclamations/${reclamationId}/annuler-cloture`);

        dispatch(annulerClotureSuccess(response.data));
        dispatch(closeAnnulerClotureDialog());


        if (!response.data.message) {
            dispatch(addNotification(`La clôture sur le dossier après-vente ${reclamationId} a bien été annulé.`, NotificationImportance.success));
        } else {
            dispatch(addNotification(`La clôture sur le dossier après-vente ${reclamationId} a bien été annulé.\n${response.data.message}`, response.data.importance, true, null));
        }

        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurEmises());
        dispatch(invalidateReclamationIndicateurAffectees());
        dispatch(invalidateReclamationIndicateurObservateur());
        dispatch(invalidateReclamationIndicateurCommentaires());
        dispatch(invalidateReclamationIndicateurCreees());
        dispatch(invalidateReclamationIndicateurCloturees());

        dispatch(invalidateTypeIndicateurs());

        dispatch(invalidateUtilisateurIndicateurs());

    } catch (error) {
        dispatch(annulerClotureFailure(error));
        dispatch(addNotification(`Impossible d'annuler la clôture sur le dossier après-vente ${reclamationId}: ${error}.`, NotificationImportance.error));
    }
};

//
// ActionCreator pour l'ajout d'une action
//
const addActionRequest = actionId => ({ type: Actions.ADD_ACTION_REQUEST, actionId });
const addActionSuccess = data => ({ type: Actions.ADD_ACTION_SUCCESS, data });
const addActionFailure = error => ({ type: Actions.ADD_ACTION_FAILURE, error });

export const addAction = (reclamationId, actionData, actionId = 0, affectationGroupeId = 0) => async (dispatch) => {

    dispatch(addActionRequest(actionId));

    let params = { ...actionData, affectationGroupeId };

    try {
        let response = await axios.post(`api/reclamations/${reclamationId}/action`, params);
        dispatch(addActionSuccess(response.data));

        // On pourrait avoir un lien vers l'action
        //let url = reclamationId + "#historique#action_" + response.data.actionId;
        //dispatch(addNotification(`Une action a bien été ajouté à la réclamation ${reclamationId}.`, NotificationImportance.success, true, url));

        if (response.data.message) {
            dispatch(addNotification(`Une action a bien été ajouté au dossier après-vente ${reclamationId}.\n${response.data.message}`, NotificationImportance.warning, true));
        }
        else {
            dispatch(addNotification(`Une action a bien été ajouté au dossier après-vente ${reclamationId}.`, NotificationImportance.success));
        }


        if (response.data.affecte) {
            dispatch(affectationSuccess(response.data.informationsAffectation));
        }
        if (response.data.observe) {
            dispatch(fetchReclamationObservateursSuccess(response.data.informationsObservation.observateurs));
        }

        var dropZone = {
            fichiers: []
        };
        dispatch(updateDropZone(dropZone));

        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurEmises());
        dispatch(invalidateReclamationIndicateurAffectees());
        dispatch(invalidateReclamationIndicateurObservateur());
        dispatch(invalidateReclamationIndicateurCommentaires());
        dispatch(invalidateReclamationIndicateurCreees());
        dispatch(invalidateReclamationIndicateurCloturees());

        dispatch(invalidateTypeIndicateurs());

        dispatch(invalidateUtilisateurIndicateurs());

    } catch (error) {
        dispatch(addActionFailure(error));
        dispatch(addNotification(`Impossible d'ajouter une action au dossier après-vente ${reclamationId}.`, NotificationImportance.error));
    }
};

//
// ActionCreator pour la suppresion d'une action
//
const deleteActionRequest = actionId => ({ type: Actions.DELETE_ACTION_REQUEST, actionId });
const deleteActionSuccess = reclamationId => ({ type: Actions.DELETE_ACTION_SUCCESS, reclamationId });
const deleteActionFailure = error => ({ type: Actions.DELETE_ACTION_FAILURE, error });

export const deleteAction = (actionId) => async (dispatch) => {

    dispatch(deleteActionRequest(actionId));

    try {
        let response = await axios.delete(`api/reclamationActions/${actionId}`);
        dispatch(deleteActionSuccess(response.data));

        dispatch(addNotification(`L'action ${actionId} a bien été supprimée du dossier après-vente ${response.data.reclamationId}.`, NotificationImportance.success));


        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurCommentaires());


    } catch (error) {
        dispatch(deleteActionFailure(error));
        dispatch(addNotification(`Impossible de supprimer l'action ${actionId}.`, NotificationImportance.error));
    }
};

/**
 * FETCH_RECLAMATION_TRANSPORTEUR_...
 * ActionCreator pour la récuperation du transporteur d'une réclamation
 */
const fetchReclamationTransporteurRequest = () => ({ type: Actions.FETCH_RECLAMATION_TRANSPORTEUR_REQUEST });
const fetchReclamationTransporteurSuccess = transporteur => ({ type: Actions.FETCH_RECLAMATION_TRANSPORTEUR_SUCCESS, transporteur });
const fetchReclamationTransporteurFailure = error => ({ type: Actions.FETCH_RECLAMATION_TRANSPORTEUR_FAILURE, error });

export const fetchReclamationTransporteur = (reclamationId) => (dispatch, getState) => {
    if (getState().reclamation.reclamations.transporteurs.isLoading) {
        return;
    }
    if (getState().reclamation.reclamations.transporteurs.items.find(x => x.reclamationId === reclamationId)) {
        return;
    }
    return dispatch(_fetchReclamationTransporteur(reclamationId));
};

const _fetchReclamationTransporteur = (reclamationId) => async (dispatch) => {

    dispatch(fetchReclamationTransporteurRequest());

    try {
        let response = await axios.get(`api/reclamations/${reclamationId}/transporteur`);

        let transporteur = {
            reclamationId: reclamationId,
            transporteurId: response.data.transporteurId,
            colis: response.data.colis
        };

        dispatch(fetchReclamationTransporteurSuccess(transporteur));
    } catch (error) {
        console.error('_fetchReclamationTransporteur : ', error);
        dispatch(fetchReclamationTransporteurFailure(error));
    }

};

//
// ActionCreator pour la modification de la date de vérification d'une réclamation
//
const setDateVerificationRequest = () => ({ type: Actions.SET_DATE_VERIFICATION_REQUEST });
const setDateVerificationSuccess = data => ({ type: Actions.SET_DATE_VERIFICATION_SUCCESS, data });
const setDateVerificationFailure = error => ({ type: Actions.SET_DATE_VERIFICATION_FAILURE, error });

export const setDateVerification = (reclamationId, date) => async (dispatch) => {

    dispatch(setDateVerificationRequest());

    let params = {
        code: TypeActionCodes.ModificationDateVerification,
        details: [{
            code: ReclamationActionDetailCodes.DateVerification,
            type: ReclamationActionDetailType.Date,
            libelle: "Nouvelle date de vérification",
            position: 0,
            valeurDate: date
        }]
    };

    try {
        let response = await axios.post(`api/reclamations/${reclamationId}/action`, params);
        dispatch(setDateVerificationSuccess(response.data));
        dispatch(addNotification(`La date de vérification a bien été modifié pour le dossier après-vente ${reclamationId}.`, NotificationImportance.success));
        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());
    } catch (error) {
        dispatch(setDateVerificationFailure(error));
        dispatch(addNotification(`Impossible de modifier la date de vérification pour le dossier après-vente ${reclamationId}.`, NotificationImportance.error));
    }
};

//
// ActionCreator pour la création d'une packing list
//
const generatePackingListRequest = () => ({ type: Actions.GENERATE_PACKING_LIST_REQUEST });
const generatePackingListSuccess = data => ({ type: Actions.GENERATE_PACKING_LIST_SUCCESS, data });
const generatePackingListFailure = error => ({ type: Actions.GENERATE_PACKING_LIST_FAILURE, error });

export const generatePackingList = (param) => async (dispatch) => {

    dispatch(generatePackingListRequest());

    try {

        let response = await axios.post(`api/reclamations/generer-packing-list`, param, { responseType: 'blob' });

        let packingListId = response.headers['x-packinglistid'];
        let message = response.headers['x-message'];

        // Echec de generation du PDF : le serveur repond en JSON (et non un blob PDF).
        // La packing list a bien ete creee, on notifie son numero et le detail de l'erreur.
        const contentType = response.headers['content-type'] || '';
        const pdfDisponible = contentType.indexOf('application/pdf') !== -1;

        if (!pdfDisponible && response.data) {
            try {
                const corps = JSON.parse(await response.data.text());
                packingListId = corps.packingListId || packingListId;
                message = corps.message || message;
            } catch (e) {
                // corps illisible : on garde les valeurs des en-tetes
            }
        }

        if (pdfDisponible) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            var contentDisposition = response.headers['content-disposition'];
            var regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

            var match = regex.exec(contentDisposition);

            let filename = match[1]; // On prend le groupe 1

            link.setAttribute('download', decodeURIComponent(filename));

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        }

        dispatch(generatePackingListSuccess(response.data));

        dispatch(addNotification(`Une packing list a bien été générée (${packingListId}).`, NotificationImportance.success));

        // Si il y a un message, ie exception après la création
        if (message) {
            dispatch(addNotification(`${message}`,
                pdfDisponible ? NotificationImportance.warning : NotificationImportance.error));
        }

        dispatch(invalidateReclamationHistorique());
        dispatch(invalidateRecherche());

        dispatch(invalidateReclamationIndicateurEmises());
        dispatch(invalidateReclamationIndicateurAffectees());
        dispatch(invalidateReclamationIndicateurObservateur());
        dispatch(invalidateReclamationIndicateurCommentaires());
        dispatch(invalidateReclamationIndicateurCreees());
        dispatch(invalidateReclamationIndicateurCloturees());

        dispatch(invalidateTypeIndicateurs());

        dispatch(invalidateUtilisateurIndicateurs());

    } catch (error) {
        dispatch(generatePackingListFailure(error));
        dispatch(addNotification(`Impossible d'ajouter une packing list.`, NotificationImportance.error));
    }
};






//
// ActionCreator pour modifier l'état "surPaletteRetour" d'une réclamation
//
const toggleSurPaletteRetourRequest = () => ({ type: Actions.TOGGLE_SUR_RETOUR_PALETTE_REQUEST });
const toggleSurPaletteRetourSuccess = data => ({ type: Actions.TOGGLE_SUR_RETOUR_PALETTE_SUCCESS, data });
const toggleSurPaletteRetourFailure = error => ({ type: Actions.TOGGLE_SUR_RETOUR_PALETTE_FAILURE, error });

export const toggleSurPaletteRetour = (reclamationId) => async (dispatch) => {

    dispatch(toggleSurPaletteRetourRequest());

    try {
        let response = await axios.patch(`api/reclamations/${reclamationId}/toggleSurPaletteRetour`);
        dispatch(toggleSurPaletteRetourSuccess(response.data));
        dispatch(addNotification(`Le marqueur "sur palette retour" du dossier après-vente ${reclamationId} a bien été inversé`, NotificationImportance.success));
    } catch (error) {
        console.error('toggleSurPaletteRetour : ', error);
        dispatch(toggleSurPaletteRetourFailure(error));
        dispatch(addNotification(`Impossible de modifier le dossier après-vente ${reclamationId}.`, NotificationImportance.error));
    }
};